import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

import { Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
// optional cofiguration
const options = {
  position: 'top center',
  timeout: 5001,
  offset: '30px',
  transition: 'scale'
}
ReactDOM.render(<AlertProvider template={AlertTemplate} {...options}><App /></AlertProvider>, document.getElementById("root"));
registerServiceWorker();
